import { ThemeProvider } from '@mui/material';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { customTheme } from './config/customTheme';
import { AuthClientEvent } from '@react-keycloak/core/lib/types';
import { keycloak as keycloakConfig } from './config/keycloak';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import AppWrapper from './AppWrapper';

const onKeycloakEvent = (event: AuthClientEvent) => {
  if (!location.pathname.includes('reset-password')) {
    if (event === 'onReady') {
      if (!keycloakConfig.authenticated) {
        keycloakConfig.login();
      }
    }
  }
};

const App = (): JSX.Element => {
  return (
    <ThemeProvider theme={customTheme}>
      <BrowserRouter>
        <ReactKeycloakProvider
          authClient={keycloakConfig}
          initOptions={{
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri:
              window.location.origin + '/silent-check-sso.html',
            pkceMethod: 'S256'
          }}
          onEvent={onKeycloakEvent}
          LoadingComponent={<LoadingScreen />}
        >
          <AppWrapper />
        </ReactKeycloakProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
